import { ArrowRight } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

export function PageHero({ eyebrow, title, description }: { eyebrow: string; title: string; description: string }) {
	return <section className="page-hero"><div className="container narrow"><p className="eyebrow">{eyebrow}</p><h1>{title}</h1><p className="lede">{description}</p></div></section>;
}

export function Section({ children, tone = "white", className = "" }: { children: ReactNode; tone?: "white" | "mist" | "navy"; className?: string }) {
	return <section className={`section section-${tone} ${className}`}><div className="container">{children}</div></section>;
}

export function ApplyBand({ title = "Have a transaction to discuss?" }: { title?: string }) {
	return <section className="apply-band"><div className="container"><div><p className="eyebrow">Start a conversation</p><h2>{title}</h2><p>Share the essentials. No sensitive financial documents are needed for the initial review.</p></div><div className="button-row"><Link className="button button-light" to="/application/">Apply Now <ArrowRight size={17} /></Link><a className="button button-outline-light" href="tel:+19165055663">Call 916-505-5663</a></div></div></section>;
}
